import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
  })
export class DateUtilService {


  constructor(


  ) { }

  removeDateReference(originalDate: Date) {
    let dateToConvert: Date = new Date(originalDate.getFullYear(), originalDate.getMonth(), originalDate.getDate());
    return dateToConvert;
  }

  datepickerTransformDate(originalDate: any, pattern: string): string {
    let dateToConvert = Object.assign(originalDate);
    let dateTransformed = new Date(dateToConvert.date.year, dateToConvert.date.month - 1, dateToConvert.date.day );
    return moment(dateTransformed).format(pattern);
  }

  formatDate(originalDate: any, pattern: string): string {
    let dateToConvert = originalDate;
    let dateTransformed = moment(dateToConvert, pattern).toDate();
    return moment(dateTransformed).format(pattern);
  }

  parseDate(originalDate: any, pattern: string): Date {
    let dateToConvert = originalDate;
    return moment(dateToConvert, pattern).toDate();
  }

  plusDays(originalDate: Date, countDays: number) {
    let dateToConvert: Date = new Date(originalDate.getFullYear(), originalDate.getMonth(), originalDate.getDate());
    dateToConvert.setDate(dateToConvert.getDate() + countDays);
    return dateToConvert;
  }

  subtractDays(originalDate: Date, countDays: number) {
    let dateToConvert: Date = this.removeDateReference(originalDate);
    dateToConvert.setDate(dateToConvert.getDate() - countDays);
    return dateToConvert;
  }

  plusMonths(originalDate: Date, countDays: number) {
    let dateToConvert: Date = this.removeDateReference(originalDate);
    dateToConvert.setMonth(dateToConvert.getMonth() + 1) ;
    return dateToConvert;
  }

  subtractMonths(originalDate: Date, countDays: number) {
    let dateToConvert: Date = this.removeDateReference(originalDate);
    dateToConvert.setMonth(dateToConvert.getMonth() - 1) ;
    return dateToConvert;
  }

  firstDayOfMonth(originalDate: Date) {
    let dateToConvert: Date = this.removeDateReference(originalDate);
    let firstDay = new Date(dateToConvert.getFullYear(), dateToConvert.getMonth(), 1);
    return firstDay;
  }

  lastDayOfMonth(originalDate: Date) {
    let dateToConvert: Date = this.removeDateReference(originalDate);
    let lastDate = new Date(dateToConvert.getFullYear(), dateToConvert.getMonth() + 1, 0);
    return lastDate;
  }

  /**
   * Compara duas datas para verificar se a primeira é maior ou igual à segunda.
   * @param date1 A primeira data para comparação (string ou Date).
   * @param date2 A segunda data para comparação (string ou Date).
   * @returns Retorna true se date1 for maior ou igual a date2, caso contrário, retorna false.
   */
  isGreater(date1: string | Date, date2: string | Date): boolean {
    // Converter date1 para objeto Date, caso seja string
    const parsedDate1 = this.parseDate(date1, 'YYYY-MM-DD');
    // Converter date2 para objeto Date, caso seja string
    const parsedDate2 = this.parseDate(date2, 'YYYY-MM-DD');

    // Zerar as horas, minutos e segundos para comparar apenas as datas
    parsedDate1.setHours(0, 0, 0, 0);
    parsedDate2.setHours(0, 0, 0, 0);
    // Comparar se a primeira data é maior ou igual à segunda data
    return parsedDate1 > parsedDate2;
  }

   /**
   * Compara duas datas para verificar se a primeira é menor que a segunda.
   * @param date1 A primeira data para comparação (string ou Date).
   * @param date2 A segunda data para comparação (string ou Date).
   * @returns Retorna true se date1 for menor que date2, caso contrário, retorna false.
   */
   isLessThanOrEqual(date1: string | Date, date2: string | Date, mask?: string): boolean {
    const parsedDate1 = this.parseDate(date1, mask || 'YYYY-MM-DD');
    const parsedDate2 = this.parseDate(date2, mask || 'YYYY-MM-DD');

    // Zerar as horas, minutos e segundos para comparar apenas as datas
    parsedDate1.setHours(0, 0, 0, 0);
    parsedDate2.setHours(0, 0, 0, 0);
    return parsedDate1 <= parsedDate2;
  }

}
